/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_Q_Wrong_ScoresInputs */



/**
* | output |
* | --- |
* | "I finished the tournament but the scores are wrong — what now?" |
*
* @param {Og_Faq_Q_Wrong_ScoresInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_q_wrong_scores = /** @type {((inputs?: Og_Faq_Q_Wrong_ScoresInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_Q_Wrong_ScoresInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("J'ai terminé le tournoi mais les scores sont incorrects — que faire ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("Finalicé el torneo pero las puntuaciones son incorrectas — ¿qué hago?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Concluí o torneio mas as pontuações estão erradas — o que fazer?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ho concluso il torneo ma i punteggi sono sbagliati — cosa faccio?")
	return /** @type {LocalizedString} */ ("I finished the tournament but the scores are wrong — what now?")
});